import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

//Import Custom Component
import Carousel from '../../features/carousel';

//Import Settings
import { owlSetting3 } from '../../../utils/settings';

//Import Data
import data from '../../../mock-data/manufacturers.json';

function ManufacturersCollection(props) {
	// const { manufacturers } = props;
	
	return (
		<div className="container">
			<div className="section-title text-center">
				<h4 className="mb-0">Producenci</h4>
			</div>

			<Carousel addClass="partners-carousel" settings={owlSetting3}>
				{
					data.map(manufacturer => (
						<figure key={manufacturer.id}>
							<Link to="#" className="partner" title={manufacturer.name}>
								<div className="lazy-overlay bg-transparent"></div>

								<LazyLoadImage
									src={`${process.env.PUBLIC_URL}/assets/images/manufacturers/` + manufacturer.image}
									alt={manufacturer.name}
									width={100}
									height={29}
									threshold={100}
									effect="blur"
								/>
							</Link>
						</figure>
					))
				}
			</Carousel>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		manufacturers: state.manufacturers.manufacturers ? state.manufacturers.manufacturers : []
	}
}

export default connect(mapStateToProps, {})(ManufacturersCollection);